"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHAPI = void 0;
const apisauce_1 = __importDefault(require("apisauce"));
const BaseAPI_1 = __importDefault(require("./BaseAPI"));
class AUTHAPI {
    static setup(config, options) {
        AUTHAPI.instance = BaseAPI_1.default.getInstance(config, options);
    }
    static async get(args) {
        return BaseAPI_1.default.get(AUTHAPI.instance, args);
    }
    static async post(args) {
        return BaseAPI_1.default.post(AUTHAPI.instance, args);
    }
    static reset() {
        return BaseAPI_1.default.reset(AUTHAPI.instance);
    }
    static createCancelToken() {
        return apisauce_1.default.CancelToken.source();
    }
}
exports.AUTHAPI = AUTHAPI;
AUTHAPI.instance = undefined;
//# sourceMappingURL=auth-api.js.map